import axios from 'axios';

// Base de la API: en producción debe venir de REACT_APP_API_BASE
// y en desarrollo, si no está definida, usa el backend local.
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000/api';
const API_URL = `${API_BASE}/financiero`;

/**
 * Obtiene el reporte de ingresos diarios.
 * @param {Object} params
 * @param {string} params.fechaInicio - Fecha inicio (YYYY-MM-DD)
 * @param {string} params.fechaFin - Fecha fin (YYYY-MM-DD)
 * @param {number} [params.campusId] - Campus opcional
 */

/**
 * Obtiene el reporte de ingresos diarios, con filtro opcional por cajero.
 * @param {Object} params
 * @param {string} params.fechaInicio - Fecha inicio (YYYY-MM-DD)
 * @param {string} params.fechaFin - Fecha fin (YYYY-MM-DD)
 * @param {number} [params.campusId] - Campus opcional
 * @param {number} [params.cajeroId] - Cajero opcional
 * @param {string} [params.estadoPago] - Estado de pago opcional (APLICADO, CANCELADO, etc.)
 */
export const getIngresosDiarios = async ({ fechaInicio, fechaFin, campusId, cajeroId, estadoPago }) => {
  const params = {};
  if (fechaInicio) params.fecha_inicio = fechaInicio;
  if (fechaFin) params.fecha_fin = fechaFin;
  if (campusId) params.campus_id = campusId;
  if (cajeroId) params.cajero_id = cajeroId;
  if (estadoPago) params.estado_pago = estadoPago;

  const url = `${API_URL}/reportes/ingresos-diarios/`;
  const response = await axios.get(url, { params });
  return response.data;
};

/**
 * Obtiene la lista de cajeros (usuarios que han registrado pagos).
 * @returns {Promise<Array<{id:number, nombre:string, usuario:string}>>}
 */
export const getCajeros = async () => {
  const url = `${API_URL}/reportes/cajeros/`;
  const response = await axios.get(url);
  return response.data?.results || [];
};

/**
 * Obtiene el reporte de adeudos por cargo.
 * @param {Object} params
 * @param {number} [params.campusId] - Campus opcional
 * @param {string} [params.search] - Búsqueda opcional (matrícula, nombre, concepto o descripción)
 */
export const getReporteAdeudos = async ({ campusId, search }) => {
  const params = {};
  if (campusId) params.campus_id = campusId;
  if (search) params.search = search;

  const url = `${API_URL}/reportes/adeudos/`;
  const response = await axios.get(url, { params });
  return response.data;
};

/**
 * Obtiene el reporte de rectoria agrupado por estudiante y parcialidad.
 * @param {Object} params
 * @param {number} [params.campusId] - Campus opcional
 * @param {string} [params.campus] - Nombre de campus opcional
 * @param {number} [params.cicloId] - Ciclo escolar opcional
 * @param {string} [params.ciclo] - Nombre de ciclo opcional
 * @param {string} [params.search] - Búsqueda por matrícula o nombre
 * @param {string|number} [params.idSeccion] - Filtro de sección opcional
 * @param {string|number} [params.idPrograma] - Filtro de programa opcional
 * @param {number} [params.page=1] - Página solicitada
 * @param {number} [params.page_size=15] - Tamaño de página
 * @param {boolean} [params.all=false] - Si true, devuelve todos los resultados
 */
export const getReporteRectoria = async ({
  campusId,
  campus,
  cicloId,
  ciclo,
  search,
  idSeccion,
  idPrograma,
  page = 1,
  page_size = 15,
  all = false,
} = {}) => {
  const params = {};
  if (campusId) params.campus_id = campusId;
  if (campus) params.campus = campus;
  if (cicloId) params.ciclo_id = cicloId;
  if (ciclo) params.ciclo = ciclo;
  if (search) params.search = search;
  if (idSeccion) params.id_seccion = idSeccion;
  if (idPrograma) params.id_programa = idPrograma;
  if (all) {
    params.all = '1';
  } else {
    params.page = page;
    params.page_size = page_size;
  }

  const url = `${API_URL}/reportes/rectoria/`;
  const response = await axios.get(url, { params });
  return response.data;
};
